import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import Close from '@mui/icons-material/Close'
import Typography from '@mui/material/Typography'
import IconButton from '@mui/material/IconButton'
import Box from  '@mui/material/Box'
import CircularProgress from '@mui/material/CircularProgress'


export default function PayToAccount(props) {
    
    return (
        <Dialog open={props.open} onClose={props.close}>
           <IconButton onClick={props.close} sx={{ justifyContent: 'end'}}>
                <Close />
            </IconButton>
            <DialogContent sx={{p: {xs: 1, sm: 4, md: 4}}}>
            <Box>
            <Typography sx={{ textAlign: 'center', color: '#818181'}}>Send the amount shown to the account details below</Typography>
            </Box>
             <Box sx={{background: "#EFEFEF", p: 2, mt: 4, mb: 4, display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center'}}>
                 <Typography sx={{color: '#818181'}}>Payment Amount</Typography>
                 <Typography>{props.amount} {props.fromCurrency?.name}</Typography>
             </Box>
             {props.paymentAccountLoader ? <CircularProgress /> : <Box sx={{mt: 4, mb: 4}}>
                 <Box sx={{background: "#EFEFEF", p: {xs: 1, sm: 4, md: 4}}}>
                 <Typography sx={{color: '#818181'}}><span style={{color: '#3A3A3A', fontWeight: 500}}>Account Name:</span> {props.payAccount?.accountName}</Typography>
                 <Typography sx={{color: '#818181'}}><span style={{color: '#3A3A3A', fontWeight: 500}}>{props.payAccount.type === "web" ? "Email:" : "Account Number:"} </span>{props.payAccount?.accountNo}</Typography>
                 <Typography sx={{color: '#818181'}}><span style={{color: '#3A3A3A', fontWeight: 500}}>{props.payAccount.type === "web" ? " " : "Bank:"}</span> {props.payAccount?.accountBank}</Typography>
                 <Typography sx={{color: '#818181'}}><span style={{color: '#3A3A3A', fontWeight: 500}}>Description:</span> {props.payAccount.type === "web" ? "Web Services" : "Bank Transfer"} </Typography>
                </Box>
                <Box sx={{display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', mt: 4}}>
                    <Typography sx={{fontSize: {xs: '14px', md: '18px', color: '#E45757', textAlign: 'center'}}}>After Initiating a transfer, screenshot the evidence and click on
                    Confirm payment to upload your proof for verification.</Typography>
                    <Button sx={{ p: 2, mt: 3, width: {xs: '100%', md: '50%'}}} onClick={props.confirmPayment} variant="contained">Confirm Payment</Button>
                </Box>
             </Box>}
            </DialogContent>
        </Dialog>
    )
}